import {useSnackbar} from 'notistack'
import {createContext, useContext, useRef, useState} from 'react'
import {useParams} from 'react-router-dom'
import {Dim} from 'src/common/types/generics/ImageDetections'
import {KonvaImageRef} from 'src/common/types/generics/KonvaImageRef'
import useSingleCamera from 'src/hooks/api/camera/useSingleCamera'
import useSnapshot from 'src/hooks/api/camera/useSnapshot'
import handleErrorWithSnackbar from 'src/utilities/handleErrorWithSnackbar'
import {CameraConfigContextData} from './CameraConfigContextData'

export const CameraConfigContext = createContext<CameraConfigContextData>({} as CameraConfigContextData)

export const CameraConfigProvider = ({children}: any) => {
  const {enqueueSnackbar} = useSnackbar()

  const {id} = useParams<{id?: string}>()

  const {data: camera, refetch: refetchCamera} = useSingleCamera({
    onError: (error) => handleErrorWithSnackbar(enqueueSnackbar, error, 'Falha ao tentar obter câmera'),
    cameraId: Number(id),
    params: {includes: ['configuration', 'configuration', 'status', 'server', 'client', 'addressInfo', 'company']},
    enabled: !!id,
  })

  const {data: snapshot, refetch: refetchSnapshot} = useSnapshot({
    cameraId: Number(id),
    enabled: !!id,
  })

  const [_dimImage, setDimImage] = useState<Dim>({width: 0, height: 0})

  const konvaImageRef = useRef<KonvaImageRef>({scale: 1, dim: {height: 0, width: 390}})

  return (
    <CameraConfigContext.Provider
      value={{
        camera,
        snapshot: snapshot?.time?.base64 ?? '',
        konvaImageRef,
        _dimImage,
        setDimImage,
        refetchSnapshot: () => {
          refetchSnapshot()
          return snapshot?.time?.base64 ?? ''
        },
        refetchCamera,
      }}>
      {children}
    </CameraConfigContext.Provider>
  )
}

export function useCameraConfigContext() {
  return useContext(CameraConfigContext)
}
